export interface MinMaxError {
  minError: boolean;
  maxError: boolean;
  message: string;
}

export const INITIAL_MIN_MAX_ERROR_VALUES = {
  minError: false,
  maxError: false,
  message: '',
};

export const checkMinMaxValue = (
  minValue: number,
  maxValue: number,
  error: MinMaxError
): MinMaxError => {
  if (maxValue && minValue && maxValue < 0 && minValue < 0) {
    return {
      minError: true,
      maxError: true,
      message: 'Min ve Max Fiyatları negatif olamaz.',
    };
  } else if (minValue && minValue < 0) {
    return { ...error, minError: true, message: 'Min Fiyat negatif olamaz.' };
  } else if (maxValue && maxValue < 0) {
    return { ...error, maxError: true, message: 'Max Fiyat negatif olamaz.' };
  } else if (minValue && maxValue && maxValue > 0 && minValue > maxValue) {
    return {
      ...error,
      maxError: true,
      message: 'Max Fiyat, Min Fiyattan büyük olmalıdır.',
    };
  }
  return INITIAL_MIN_MAX_ERROR_VALUES;
};
